export default __webpack_public_path__ + "static/media/right-arrow.580b9789.svg";